import { render, staticRenderFns } from "./medicamentos.vue?vue&type=template&id=2136f4fd&scoped=true"
import script from "./medicamentos.vue?vue&type=script&lang=js"
export * from "./medicamentos.vue?vue&type=script&lang=js"
import style0 from "./medicamentos.vue?vue&type=style&index=0&id=2136f4fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2136f4fd",
  null
  
)

export default component.exports